import { types } from "mobx-state-tree";

import CONSTANTS from "const/constants";

import { UserCredentialBaseStore } from "./user-credential-base-store";

const { CREDENTIAL_TYPE_LABELS, PLATFORM_TYPES } = CONSTANTS;

const model = {
    tikTokDisplayName: types.maybeNull(types.string),
    tikTokAvatar: types.maybeNull(types.string),
    tikTokOpenId: types.maybeNull(types.string)
};

const volatile = (self) => {
    const __name__ = self.name;
    const __profileImage__ = self.profileImage;

    return {
        name: self?.tikTokDisplayName ?? __name__,
        profileImage: self?.tikTokAvatar ?? __profileImage__,
        typeLabel: CREDENTIAL_TYPE_LABELS.TIKTOK,
        platformType: PLATFORM_TYPES.TIKTOK,
        shareKey: `shareViaTiktokCount`
    };
};

const viewOverrides = (self) => {
    return {
        isSocialMedia() {
            return true;
        }
    };
};

const actions = (self) => {
    const __onShareSuccessful__ = self.onShareSuccessful;

    return {
        onShareSuccessful(response) {
            return __onShareSuccessful__.call(self, self.shareKey, response);
        }
    };
};

const _UserCredentialTikTokStore = types
    .model(`UserCredentialTikTok`, model)
    .volatile(volatile)
    .views(viewOverrides)
    .actions(actions);

export const UserCredentialTikTokStore = types
    .compose(UserCredentialBaseStore, _UserCredentialTikTokStore)
    .named(`UserCredentialTikTokStore`);
